import * as React from "react";
import { forwardRef } from "react";
const SvgMarkAccepted = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 10, height: 9, viewBox: "0 0 10 9", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M9 1.25L3.5 7.20833L1 4.5", stroke: "white", strokeWidth: 1.6, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgMarkAccepted);
export { ForwardRef as ReactComponent };
